export default __webpack_public_path__ + "static/media/energyConsumptionIcon.c2371870.svg";